// libs.
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

// types.
import { AlertTypes } from '../../Pricing/components/AlertToast/AlertToast';

interface UseHandleMutationToastParams {
  isError: boolean;
  isSuccess: boolean;
  setShowModal: (value: boolean) => void;
  setAlert: (options: {
    type: AlertTypes;
    text: string;
    show: boolean;
  }) => void;
  clearState?: () => void;
}

export const useHandleMutationToast = ({
  isError,
  isSuccess,
  setShowModal,
  setAlert,
  clearState,
}: UseHandleMutationToastParams) => {
  const navigate = useNavigate();

  useEffect(() => {
    if (isError) {
      setAlert({
        type: 'error',
        text: 'Error al reasignar esta tarea',
        show: true,
      });
      clearState?.();
    }
  }, [isError]);

  useEffect(() => {
    if (isSuccess) {
      setAlert({
        type: 'success',
        text: 'Tarea(s) asignada(s) correctamente',
        show: true,
      });
      clearState?.();
      setShowModal(false);
      navigate('/tareas-aprobologo');
    }
  }, [isSuccess]);
};
